(() => {
  const KEY = 'wb_wishlist_v1';
  const channel = ('BroadcastChannel' in window) ? new BroadcastChannel('wb_wishlist') : null;

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  };

  const emit = (items = read()) => {
    window.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { items } }));
    channel?.postMessage({ type: 'changed' });
  };

  const set = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    emit(items);
    return items;
  };

  const has = (variantId) => read().some(i => String(i.variantId) === String(variantId));

  // IMPORTANT: upgrades existing items if they were saved with incomplete data earlier
  const add = (entry) => {
    const items = read();
    const idx = items.findIndex(i => String(i.variantId) === String(entry.variantId));

    if (idx >= 0) {
      items[idx] = { ...items[idx], ...entry };
    } else {
      items.unshift({ ...entry, addedAt: Date.now() });
    }

    return set(items);
  };

  const remove = (variantId) =>
    set(read().filter(i => String(i.variantId) !== String(variantId)));

  const toggle = (entry) => (has(entry.variantId) ? remove(entry.variantId) : add(entry));
  const clear = () => set([]);

  // Cross-tab updates
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) emit();
  });

  channel?.addEventListener('message', (e) => {
    if (e.data?.type === 'changed') emit();
  });

  window.WBWishlist = { read, set, add, remove, toggle, has, clear, KEY };
})();
